import React, { FC, useMemo } from "react";
import classNames from "classnames";
import { ParcelCategoryUZ, Theme } from "@/enums";
import { useTheme } from "@/context/Theme.context";
import { getCategoryDetails } from "@/utils/CategoryUtils";

type TProps = {
  category: ParcelCategoryUZ;
  shipmentTypeParentId?: number;
  wrapperClassName?: string;
};

const Category: FC<TProps> = ({
  category,
  shipmentTypeParentId,
  wrapperClassName,
}) => {
  const theme = useTheme();

  const categoryDetails = useMemo(() => {
    return getCategoryDetails(category, theme as Theme, shipmentTypeParentId);
  }, [category, shipmentTypeParentId, theme]);

  const iconKey =
    shipmentTypeParentId != null ? shipmentTypeParentId : category;
  const Icon =
    categoryDetails?.icons[iconKey] ||
    categoryDetails.icons[ParcelCategoryUZ.OTHER];

  return (
    <div
      className={classNames(
        "flex h-11 w-11 items-center justify-center rounded-full",
        categoryDetails?.wrapperStyles,
        wrapperClassName,
      )}
    >
      {
        <Icon
          className={classNames(
            "w-fit-content h-auto",
            categoryDetails?.iconStyles,
          )}
        />
      }
    </div>
  );
};

export { Category };
